export const ShiftsTableSkeleton = () => {
  return (
    <div className="w-full">
      <div className="h-96 w-full animate-pulse rounded-2xl bg-skeleton" />
    </div>
  )
}
